import React from "react";
import MarkdownPage from "../components/MarkdownPage";

function Home() {
  return <MarkdownPage markdownPath="/markdown/home.md" />;
}

export default Home;
